module.exports = __webpack_public_path__ + "media/images/icons/calendar-icon-aaf3d98c6cc182f35fed8351f4856fc3.svg";